
import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import SkillsSection from './components/SkillsSection';
import ExperienceSection from './components/ExperienceSection';
import ProjectsSection from './components/ProjectsSection';
import EducationSection from './components/EducationSection';
import Footer from './components/Footer';

export default function Home() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setShowScrollTop(scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className={`min-h-screen bg-[#0d1117] text-white transition-opacity duration-1000 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
      {/* Background Pattern */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div 
            className="absolute inset-0"
            style={{
              backgroundImage: `
                radial-gradient(circle at 20% 50%, rgba(62, 207, 142, 0.1) 0%, transparent 50%),
                radial-gradient(circle at 80% 80%, rgba(45, 212, 191, 0.1) 0%, transparent 50%),
                linear-gradient(rgba(62, 207, 142, 0.03) 1px, transparent 1px),
                linear-gradient(90deg, rgba(62, 207, 142, 0.03) 1px, transparent 1px)
              `,
              backgroundSize: '100% 100%, 100% 100%, 100px 100px, 100px 100px',
              backgroundPosition: '0 0, 0 0, 0 0, 0 0'
            }}
          />
        </div>
      </div>

      <main className="relative z-10">
        {/* Hero Section - Full Screen */}
        <HeroSection />
        
        {/* Divider with gradient */}
        <div className="relative h-px bg-gradient-to-r from-transparent via-[#3ECF8E]/30 to-transparent" />
        
        {/* About Section */}
        <div className="relative">
          <AboutSection />
        </div>
        
        {/* Divider */}
        <div className="relative h-px bg-gradient-to-r from-transparent via-[#3ECF8E]/20 to-transparent" />
        
        {/* Skills Section */}
        <div className="relative">
          <SkillsSection />
        </div>
        
        {/* Divider */}
        <div className="relative h-px bg-gradient-to-r from-transparent via-[#3ECF8E]/20 to-transparent" />
        
        {/* Experience Section */}
        <div className="relative">
          <ExperienceSection />
        </div>
        
        {/* Divider */}
        <div className="relative h-px bg-gradient-to-r from-transparent via-[#3ECF8E]/20 to-transparent" />
        
        {/* Projects Section */}
        <div className="relative">
          <ProjectsSection />
        </div>
        
        {/* Divider */}
        <div className="relative h-px bg-gradient-to-r from-transparent via-[#3ECF8E]/20 to-transparent" />
        
        {/* Education Section */}
        <div className="relative">
          <EducationSection />
        </div>
      </main>
      
      {/* Footer */}
      <Footer />

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-8 right-8 z-50 w-12 h-12 rounded-full bg-gradient-to-r from-[#3ECF8E] to-[#2dd4bf] hover:from-[#2dd4bf] hover:to-[#3ECF8E] text-black shadow-lg shadow-[#3ECF8E]/30 hover:shadow-[#3ECF8E]/50 transition-all duration-300 flex items-center justify-center group ${
          showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
        aria-label="맨 위로 이동"
      >
        <i className="ri-arrow-up-line text-2xl group-hover:scale-110 transition-transform duration-300" />
      </button>
    </div>
  );
}
